import * as Yup from "yup";
export const personKorrespondanceForm = (
  personId: string,
  personKorrespondanceId: string,
): FormConfig<any> => {
  const config: FormConfig<any> = {
    title: "korresponcance",
    form: [
      {
        component: "datepicker",
        id: "opretDato",
        label: "Oprettet dato",
        initialValue: "",
      },
      {
        component: "textinput",
        id: "beskrivelse",
        label: "Beskrivelse",
        initialValue: "",
      },
    ],
    validationSchema: Yup.object({}),
    lockedValues: [
      {
        id: "personId",
        value: personId,
      },
      {
        id: "personKorrespondanceId",
        value: personKorrespondanceId,
      },
    ],
    get: `person/${personId}/korrespondancer/${personKorrespondanceId}`,
    getDocument: `person/${personId}/korrespondancer/${personKorrespondanceId}/dokument`,
    downloadLink: `person/${personId}/korrespondancer/${personKorrespondanceId}/download`,
    delete() {
      return {
        query: `person/${personId}/korrespondancer/${personKorrespondanceId}`,
      };
    },
  };
  return config;
};
